export enum TransferenceType {
  ENTRADA = 'ENTRADA',
  SAIDA = 'SAIDA',
  TRANSFERENCIA = 'TRANSFERENCIA',
  CONTAGEM = 'CONTAGEM',
  CONTAGEM_PARCIAL = 'CONTAGEM_PARCIAL',
  APLICACAO = 'APLICACAO',
  TRANSFERENCIA_PARA_APLICACAO = 'TRANSFERENCIA_PARA_APLICACAO',
}
